import { FETCH_TAG_SUCCESS } from './fetch-tag';
import { FETCH_TAGS_SUCCESS } from './fetch-tags';
export const tagsReducer = (state = [], { type, payload } = {}) => {
    switch (type) {
        case FETCH_TAG_SUCCESS:
            return [...state, payload];
        case FETCH_TAGS_SUCCESS:
            return payload;
        default:
            return state;
    }
};
export default tagsReducer;
//# sourceMappingURL=tags-reducer.js.map